import { Image } from "react-bootstrap";
import NoImage from "../../../assests/images/gnp_noimg.png"
import {
    ProfileSection,
    ProfileImage,
    ProfileName,
    ProfileReview,
    ProfileDetails,
} from './profileStyle'
import { ProfileProps } from '../../../utils/types';

const Profile = ({profileReviewData}:ProfileProps) => {
  return (
       <ProfileSection>
              <ProfileImage><Image src={profileReviewData?.profile_picture||NoImage} alt={"profile picture"}/></ProfileImage>
              <ProfileDetails>
                     <ProfileName className='profile-user-name'>{profileReviewData?.reviewerName}</ProfileName>
                     <ProfileReview className='profile-views'>{`${profileReviewData?.profile_views} Profile Views`}</ProfileReview>
                     <ProfileReview className='profile-review'>{`${profileReviewData?.review_count} Reviews`}</ProfileReview>
              </ProfileDetails>
       </ProfileSection> 
  )
}

export default Profile
